import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * /seller без суффикса — исторический landing. Плоскость роутов (plan §6)
 * держит фичи за /seller/dashboard, /seller/consultations, /seller/analytics,
 * поэтому сюда любой заход сразу уводим на dashboard.
 */
export const Route = createFileRoute('/seller/')({
  beforeLoad: () => {
    throw redirect({ to: '/seller/dashboard' })
  },
})
